import {connect} from 'react-redux'

import {adProductSelector} from 'data/redux/selectors/productSelector';
import {getDeleteProductActionCreator, getLoadProductActionCreator} from 'data/redux/actions/productsActions';
import DenyButton
  from 'gui/pages/mainRouter/pages/ad/components/commons/adControlTopLine/components/approveDenyButtons/components/denyButton';

const mapStateToProps = (state, {product}) => {
  return {
    product: product || adProductSelector(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cancel: (id) => dispatch(getDeleteProductActionCreator(id)).then(() => dispatch(getLoadProductActionCreator(id))),
  };
};

const DenyButtonContainer = connect(mapStateToProps, mapDispatchToProps)(DenyButton as any) as any;

export default DenyButtonContainer;
